import {useEffect} from 'react'
import {CarEditModalHeader} from './CarEditModalHeader'
import {CarEditModalFormWrapper} from './CarEditModalFormWrapper'

const CarEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_car'
        role='dialog'
        tabIndex={-1}
        area-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <CarEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body  over'>
              <CarEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {CarEditModal}
